/*
 * Copyright (c) 2025.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Dmitri Puscas
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { CustomerGroup } from './CustomerGroup';
import { Manufacturer } from './Manufacturer';
import { ProductGroup } from './ProductGroup';

export interface ExclusionMatrixRelated {
  customerGroups: CustomerGroup[];  
  productGroups: ProductGroup[];
  manufacturers: Manufacturer[];  
}